import { gql } from '../../__generated__/gql'

export const EXIT_SPOOFING_MUTATION = gql(`
  mutation exitSpoofing {
    exitSpoofing(input: {}) {
      spoofedUserId
    }
  }
`)
